module.exports = __webpack_public_path__ + "img/estuco_premium_mezcla_brava.09377ac1.png";